import { cva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const loadingSpinnerRecipe = cva({
    base: {
        display: 'flex',
        animation: 'spin infinite linear',
        color: 'elements.default.fill',
    },
    variants: {
        duration: {
            fast: {
                animationDuration: '0.5s',
            },
            medium: {
                animationDuration: '0.75s',
            },
            slow: {
                animationDuration: '1.0s',
            },
        },
        size: {
            // These don't quite match up with icon size tokens
            // so they are just explicit values
            small: {
                width: '[16px]',
                height: '[16px]',
                '& svg': {
                    width: '[16px]',
                    height: '[16px]',
                },
            },
            medium: {
                width: '[32px]',
                height: '[32px]',
                '& svg': {
                    width: '[32px]',
                    height: '[32px]',
                },
            },
            large: {
                width: '[64px]',
                height: '[64px]',
                '& svg': {
                    width: '[64px]',
                    height: '[64px]',
                },
            },
            full: {
                width: '[100%]',
                height: '[100%]',
                '& svg': {
                    width: '[100%]',
                    height: '[100%]',
                },
            },
            unset: {
                width: '[unset]',
                height: '[unset]',
            },
        },
        color: {
            primary: {
                color: 'elements.primary.fill',
            },
            secondary: {
                color: 'elements.secondary.fill',
            },
            tertiary: {
                color: 'elements.tertiary.fill',
            },
        },
    },
    defaultVariants: {
        size: 'medium',
        duration: 'medium',
    },
});

type LoadingSpinnerRecipeProps = RecipeVariantProps<typeof loadingSpinnerRecipe>;

export { loadingSpinnerRecipe, loadingSpinnerRecipe as default };
export type { LoadingSpinnerRecipeProps };
